import { Routes, RouterModule } from '@angular/router';
import { LogComponent } from './log.component';

const routes: Routes = [
    {
        path: '',
        component: LogComponent
    },
];

export const LogRoutes = RouterModule.forChild(routes);
